export default "__VITE_ASSET__8ef0bc6f__"